import { Input } from "@/shadcn/components/ui/input";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shadcn/components/ui/tooltip";
import React from "react";

type TimerCellTitleProps = {
  title: string;
  className: string;
  editedTitle?: string;
  editing: boolean;
  inputID: string;
  handleEditField?: (value: string) => void;
};

const TimerCellTitle: React.FC<TimerCellTitleProps> = ({
  title,
  className,
  editedTitle,
  editing,
  inputID,
  handleEditField,
}) => {
  return editing && editedTitle !== undefined && handleEditField ? (
    <div className={className}>
      <Input
        id={inputID}
        value={editedTitle}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => handleEditField(e.target.value)}
      />
    </div>
  ) : (
    <TooltipProvider>
      <Tooltip delayDuration={400}>
        <TooltipTrigger asChild>
          <div className={className}>
            <div className="px-0 truncate">
              {editedTitle ? editedTitle : title}
            </div>
          </div>
        </TooltipTrigger>
        <TooltipContent
          className="bg-accent outline outline-1 outline-white dark:outline-neutral-700/35 text-accent-foreground text-[15px]"
          align="start"
        >
          <div className="">{editedTitle ? editedTitle : title}</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default TimerCellTitle;
